import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
export class DocumentDetail extends BaseMessage {
    idDocNumber;
    documentIssuingCountry;
}
__decorate([
    Field.string({
        description: 'Id document number',
        pattern: '^[A-Za-z0-9 ]*$',
    }),
    __metadata("design:type", String)
], DocumentDetail.prototype, "idDocNumber", void 0);
__decorate([
    Field.string({
        description: 'Id document issuing country',
    }),
    __metadata("design:type", String)
], DocumentDetail.prototype, "documentIssuingCountry", void 0);
//# sourceMappingURL=DocumentDetail.js.map